/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */


(function() {
    // Add custom code below this line




    // Cart badge and automatic-discount progress update
    function formatCartMoney(amount, currency) {
        var roundedAmount = Math.max(0, Math.round(Number(amount) || 0));
        var hasCents = roundedAmount % 100 !== 0;

        return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
            style: 'currency',
            currency: currency || 'EUR',
            minimumFractionDigits: hasCents ? 2 : 0,
            maximumFractionDigits: 2
        }).format(roundedAmount / 100);
    }

    function hasPercentageDiscount(cart, percentage) {
        var discounts = cart.cart_level_discount_applications || cart.discount_applications || [];

        return discounts.some(function(discount) {
            var valueMatches = discount.value_type === 'percentage' && parseFloat(discount.value) >= percentage;
            var titleMatches = new RegExp('(^|\\D)' + percentage + '\\s*%').test(discount.title || '');
            return valueMatches || titleMatches;
        });
    }

    function updateDiscountProgress(cart) {
        var subtotal = Number(cart.items_subtotal_price || 0);
        var currencyRate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;

        document.querySelectorAll('[data-cart-discount-progress]').forEach(function(container) {
            var thresholds = container.dataset.discountThresholds.split(',').map(function(value) {
                return Number(value) * currencyRate;
            });
            var rates = container.dataset.discountRates.split(',').map(Number);
            var freeShippingThreshold = Number(container.dataset.freeShippingThreshold || 0) * currencyRate;
            var progressMaximum = Number(container.dataset.progressMaximum || 0) * currencyRate ||
                Math.max(thresholds[thresholds.length - 1], freeShippingThreshold);
            var message = container.querySelector('[data-discount-progress-message]');
            var fill = container.querySelector('[data-discount-progress-fill]');
            var track = container.querySelector('[role="progressbar"]');
            var maximumIndex = thresholds.length - 1;
            var nextIndex = thresholds.findIndex(function(threshold) {
                return subtotal < threshold;
            });
            var nextDiscountThreshold = nextIndex === -1 ? Infinity : thresholds[nextIndex];
            var freeShippingIsNext = freeShippingThreshold > subtotal && freeShippingThreshold <= nextDiscountThreshold;
            var rewardsShareThreshold = freeShippingIsNext &&
                Math.round(freeShippingThreshold) === Math.round(nextDiscountThreshold);
            var progress = Math.max(0, Math.min(100, (subtotal / progressMaximum) * 100));

            container.hidden = cart.item_count === 0;

            if (freeShippingIsNext) {
                var shippingRemaining = freeShippingThreshold - subtotal;

                message.textContent = rewardsShareThreshold ?
                    'Plus que ' + formatCartMoney(shippingRemaining, cart.currency) + ' pour bénéficier de la livraison offerte et de -' + rates[nextIndex] + '% !' :
                    'Plus que ' + formatCartMoney(shippingRemaining, cart.currency) + ' pour bénéficier de la livraison offerte !';
            } else if (nextIndex === -1) {
                message.textContent = hasPercentageDiscount(cart, rates[maximumIndex]) ?
                    '🎉 Félicitations ! Votre remise de -' + rates[maximumIndex] + '% est appliquée !' :
                    '🎉 Félicitations ! Le palier de -' + rates[maximumIndex] + '% est atteint !';
            } else {
                var remaining = nextDiscountThreshold - subtotal;

                message.textContent = 'Plus que ' + formatCartMoney(remaining, cart.currency) + ' pour bénéficier de -' + rates[nextIndex] + '% !';
            }

            container.querySelectorAll('[data-milestone-threshold]').forEach(function(milestone) {
                var milestoneThreshold = Number(milestone.dataset.milestoneThreshold) * currencyRate;
                milestone.classList.toggle('is-reached', subtotal >= milestoneThreshold);
            });

            fill.style.setProperty('--discount-progress', progress + '%');
            track.setAttribute('aria-valuenow', Math.round(progress));
        });
    }

    function refreshCartExtras() {
        fetch(window.theme.routes.root + 'cart.js')
            .then(function(response) {
                if (!response.ok) throw new Error('Unable to refresh cart extras');
                return response.json();
            })
            .then(function(data) {
                var count = data.item_count;
                document.querySelectorAll('[data-cart-badge]').forEach(function(badge) {
                    badge.textContent = count;
                });
                updateDiscountProgress(data);
            })
            .catch(function(error) {
                console.warn(error);
            });
    }

    document.addEventListener('theme:cart:added', refreshCartExtras);
    document.addEventListener('theme:cart:loaded', refreshCartExtras);

    // Add click event listeners to all elements with class "product-single__thumbnail"
    const thumbnailElements = document.querySelectorAll('.product-single__thumbnail');

    thumbnailElements.forEach(thumbnail => {
        thumbnail.addEventListener('click', () => {

            // Check if the device's width is superior to 768px
            if (window.innerWidth > 768) {
                // Get the data-id attribute value of the clicked thumbnail
                const dataId = thumbnail.getAttribute('data-id');

                // Find the corresponding media slide element with the same data-id
                const mediaSlide = document.querySelector(`.product-single__media-slide[data-id="${dataId}"]`);
                console.log(mediaSlide);

                // Scroll to the media slide element
                if (mediaSlide) {
                    mediaSlide.scrollIntoView({
                        block: "start",
                        behavior: 'smooth'
                    });
                }
            }
        });
    });


    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
})();
